var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPriceTag = function SvgIconPriceTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.75 3h-6.187L3.49 10.328a1.655 1.655 0 0 0 0 2.352l4.832 4.828c.312.312.812.488 1.125.488.312 0 .89-.152 1.226-.488l7.329-7.008V4.25L16.75 3Zm-1.199 4.012a1.253 1.253 0 0 1-1.613-1.2c0-.69.559-1.25 1.25-1.25.809 0 1.438.766 1.2 1.614a1.216 1.216 0 0 1-.837.836Z"
  })));
};
export default SvgIconPriceTag;